import debounce from "../helpers/debounce";
import MagicLine from "./magicLine";
import {getSiblings} from "../helpers/dom";

let toggleButton = document.querySelector('.toggle-button');
let nav = document.querySelector('.navigation');
let menu = document.querySelector('.navigation-menu');
let body = document.querySelector('body');
let header = document.querySelector('header');
let magicLine;
document.documentElement.style.setProperty('--scroll-y', '0');

if (toggleButton) {
  toggleButton.addEventListener('click', () => {
    toggleButton.classList.toggle('active');
    nav.classList.toggle('active');
    body.classList.toggle('menu-open');
    if (body.classList.contains('menu-open')) {
      body.style.top = '-' + document.documentElement.style.getPropertyValue('--scroll-y');
    } else {
      window.scrollTo(0, parseInt(body.style.top || '0') * -1);
      body.style.top = 'auto';
    }
  });
}

if (header) {
  window.addEventListener('scroll', debounce(() => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    window.scrollY < 5 ? header.classList.remove('scrolled') : header.classList.add('scrolled')
  }, 100));

  window.scrollY < 5 ? header.classList.remove('scrolled') : header.classList.add('scrolled');
}

if (!magicLine) {
  magicLine = new MagicLine(document.querySelector('.page-header .collapsible'));
}

let dropdowns = header.querySelectorAll('.navigation-menu > li .caret');
Array.prototype.forEach.call(dropdowns, (el) => {
    let all = header.querySelectorAll('.navigation-menu > li');

    if (window.innerWidth < 1280) {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        let current = e.currentTarget.parentElement.parentElement;
        let others = getSiblings(current);

        Array.prototype.forEach.call(others, (_el) => {
          _el.classList.remove('open');
        });

        current.classList.toggle('open');
      });

      document.addEventListener('click', (e) => {
        let isClickInside = menu.contains(e.target);

        if (!isClickInside) {
          Array.prototype.forEach.call(all, (_el) => {
            _el.classList.remove('open');
          });
        }
      });
    } else {
      Array.prototype.forEach.call(all, (_el) => {
        _el.classList.remove('open');
      });
    }
  }
);
